// FilePreview.jsx
import React from "react";
import config from "../../config";

const FilePreview = ({ files, onImageClick }) => {
  if (!files || files.length === 0) return null;

  const download_file = (fileUrl, fileName) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName || "download";
    link.click();
  };
function FileNameDisplay({ fileName }) {
  return <p className="text-primary">{fileName.split("/").pop()}</p>;
}
  return (
    <div className="file_message">
      {files.map((file, index) => {
        // Case 1: File object from input
        const isFileObj = file instanceof File;

        const fileUrl = isFileObj
          ? URL.createObjectURL(file) // create temp URL for File objects
          : file?.image_url?.url || `${config.api.API_URL}/${file}`;

        const fileName = isFileObj ? file.name : file;

        const extension = fileName.split(".").pop().toLowerCase();

        const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
        const pdfExtensions = ["pdf"];
        const wordExtensions = ["doc", "docx"];
        const excelExtensions = ["xls", "xlsx"];
        const pptExtensions = ["ppt", "pptx"];

        if (imageExtensions.includes(extension)) {
          return (
            <img
              key={index}
              src={fileUrl}
              alt={fileName}
              className="img-fluid"
              onClick={() => onImageClick && onImageClick(fileUrl)}
            />
          );
        } else if (pdfExtensions.includes(extension)) {
          return (
            <a
              key={index}
              href={fileUrl}
              download={fileName}
              className="file-preview text-center"
            >
              <span>
                <i className="ri-file-pdf-line " style={{ fontSize: "30px" }} /></span>
              {/* <p className="text-primary">{fileName}</p> */}
              <FileNameDisplay fileName={fileName} />
            </a>
          );
        } else if (wordExtensions.includes(extension)) {
          return (
            <a
              key={index}
              href={fileUrl}
              download={fileName}
              className="file-preview text-center"
            >
              <span>
              <i
                className="ri-file-word-line "
                style={{ fontSize: "30px" }}
              /></span>
              {/* <p className="text-primary">{fileName}</p> */}
              <FileNameDisplay fileName={fileName} />
            </a>
          );
        } else if (excelExtensions.includes(extension)) {
          return (
            <a
              key={index}
              href={fileUrl}
              download={fileName}
              className="file-preview text-center"
            >
              <span>
              <i
                className="ri-file-excel-line"
                style={{ fontSize: "30px" }}
              /></span>
              {/* <p className="text-primary">{fileName}</p> */}
              <FileNameDisplay fileName={fileName} />
            </a>
          );
        } else if (pptExtensions.includes(extension)) {
          return (
            <a
              key={index}
              href={fileUrl}
              download={fileName}
              className="file-preview text-center"
            >
              <span>
              <i
                className="ri-file-ppt-2-line"
                style={{ fontSize: "30px" }}
              /></span>
              {/* <p className="text-primary">{fileName}</p> */}
              <FileNameDisplay fileName={fileName} />
            </a>
          );
        } else {
          return (
            <a
              key={index}
              href={fileUrl}
              download={fileName}
              className="file-preview text-center"
            ><span>
              <i
                className="ri-file-line"
                style={{ fontSize: "30px" }}
              /></span>
              {/* <p className="text-primary">{fileName}</p> */}
              <FileNameDisplay fileName={fileName} />
            </a>
          );
        }
      })}
    </div>
  );
};

export default FilePreview;
